import { createAction } from 'redux-actions';

export const toggleCheckedItem = createAction('ASSIGNED_TOGGLE_CHECKED_ITEM');
export const uncheckAllItem = createAction('ASSIGNED_UNCHECK_ALL_ITEM');
export const setAssignedActiveTab = createAction('SET_ASSIGNED_ACTIVE_TAB');

export const toggleCheckedItemById = (itemId) => (dispatch) => {
  dispatch(toggleCheckedItem(itemId));
};

export const uncheckAllItems = () => (dispatch) => {
  dispatch(uncheckAllItem());
};

export const setActiveTab = (tab) => (dispatch) => {
  dispatch(setAssignedActiveTab(tab));
  dispatch(uncheckAllItem());
};
